import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { DEFAULT_COOKIE_PREFERENCES, getCookiePreferences, saveCookiePreferences } from '../utils/cookies';

export const CookieBanner: React.FC<{ onOpenSettings: () => void }> = ({ onOpenSettings }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const existing = getCookiePreferences();
    setIsVisible(!existing);
  }, []);

  const handleSave = (next: { analytics: boolean; marketing: boolean }) => {
    saveCookiePreferences({
      ...DEFAULT_COOKIE_PREFERENCES,
      analytics: next.analytics,
      marketing: next.marketing,
      updatedAt: new Date().toISOString(),
    });
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-4 z-50 px-4">
      <div className="mx-auto max-w-4xl rounded-2xl border border-border bg-surface/95 shadow-xl backdrop-blur-md">
        <div className="flex flex-col gap-4 px-5 py-4 md:flex-row md:items-center md:justify-between">
          <div className="space-y-2 text-sm text-muted">
            <p className="text-base font-semibold text-text">We use cookies</p>
            <p>
              We use essential cookies for security and login. Optional cookies are disabled unless you choose to enable them.
            </p>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/cookie-policy" className="text-primary underline underline-offset-2">
                Cookie policy
              </Link>
              <button
                type="button"
                onClick={onOpenSettings}
                className="text-primary underline underline-offset-2"
              >
                Cookie settings
              </button>
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <Button
              variant="outline"
              size="sm"
              className="w-40"
              onClick={() => handleSave({ analytics: false, marketing: false })}
            >
              Reject optional
            </Button>
            <Button
              variant="primary"
              size="sm"
              className="w-40"
              onClick={() => handleSave({ analytics: true, marketing: true })}
            >
              Accept all
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
